import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function addBudget(budgetRequest) {
    const response = await axiosInstance.post(
        `${API_URL}/budgets/add`,
        budgetRequest
    );
    return response;
}